<template>
  <div>
    <vue-headful v-if="page.fields.seo" :title="page.fields.seo.seo_title" :description="page.fields.seo.meta_description" />
    <SeoSchema v-if="page.fields.seo" :json="page.fields.seo.schema" />
    <ExperienceHeader :experience="experience" :Breadcrumbs="Breadcrumbs"  class="park-mb-100"/>
    <UniqueDataSlider :actionTitle="experience.sliderActionTitle" :title="experience.sliderMainTitle" :description="experience.sliderDesc" :slides="experience.birds" class="mb-100" />
    <FindYourFlock :flock="experience.flock" />
    <ExperienceList v-on:reloadExperiencesMap="reloadExperiencesMap" v-if="experience && experience.locations && loaded" :experienceTitle="experience.title ? experience.title : ''" :locations="experience.locations" :headline_title="page.fields.headline_title" :headline_text="page.fields.headline_text" :results_title="`${experience.title} Sites`" slug="birding" mapDestinationType="Outdoors" ariaLabel="Find an Alabama Birding Site" class="park-mb-100" />
    <SoundsOfHappy :title="experience.soundsTitle" :description="experience.soundsDescription" />
    <FollowABirder :title="experience.followABirder.title" :subtitle="experience.followABirder.subtitle"
      :description="experience.followABirder.description" :birders="experience.followABirder.birders" />
    <Crowdriff
      :id="page.fields.crowdriff_gallery.id"
      :aria-label="page.fields.crowdriff_gallery.aria_label"
      :title="page.fields.crowdriff_gallery.title"
      :intro="page.fields.crowdriff_gallery.intro"
      class="cr-birding"
    />
    <iframe style="border: none;" width="100%" height="800"
      src="https://upload.crowdriff.com/alabama-tourism-department-65863ca5" allow="fullscreen"></iframe>
      <section class="featured-exp" v-if="experience.featuredExperience.length" >
        <FeaturedExperiences  v-for="(exp, index) in experience.featuredExperience" :key="index"
        :index="index" :title="exp.name" :description="exp.description" :link="exp.url" :link_text="''"
        :image="exp.image" :imageAlt="exp.image_alt_text" :reversed="!!(index % 2)" />
      </section>
    <OtherResources :title="experience.resourcesTitle" :description="experience.resourcesDescription"
      :otherResources="experience.otherBirdingResources" ariaLabel="Find Other Resources for Alabama Birding"
      class="or-birding" />
    <Feedback pageType="page"/>
    <Footer />
  </div>
</template>

<script>
import Crowdriff from '@/components/Common/Crowdriff.vue';
import Footer from '@/components/Common/Footer.vue';
import OtherResources from '@/components/Common/OtherResources.vue';
import UniqueDataSlider from '@/components/Common/UniqueDataSlider.vue';
import ExperienceHeader from '@/components/Experiences/Common/ExperienceHeader.vue';
import ExperienceList from '@/components/Experiences/Common/ExperienceList.vue';
import axios from 'axios';
import Butter from 'buttercms';
import { Component, Vue } from 'vue-property-decorator';
import FindYourFlock from '../components/Experiences/Common/ExperienceFindYourFlock.vue';
import FollowABirder from '../components/Experiences/Common/ExperienceFollowABirder.vue';
import SoundsOfHappy from '../components/Experiences/Common/ExperienceSoundsOfHappy.vue';
import FeaturedExperiences from '../components/Experiences/Common/FeaturedExperiences.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  components: {
    ExperienceHeader,
    UniqueDataSlider,
    OtherResources,
    Crowdriff,
    ExperienceList,
    FollowABirder,
    Footer,
    SoundsOfHappy,
    FindYourFlock,
    FeaturedExperiences,
  },
  data() {
    return {
      birding_badge_id: [process.env.VUE_APP_BADGEID3],
      page: {
        fields: {},
      },
      categorySlug: 'outdoors',
      loaded: false,
      experience: {
        slug: 'birding',
        title: null,
        iconName: null,
        content: null,
        imageUrl: null,
        imageAlt: null,
        imageCaption: null,
        imageLink: null,
        birds: [{}],
        soundsTitle: null,
        soundsDescription: null,
        sliderActionTitle: null,
        sliderMainTitle: null,
        sliderDesc: null,
        flock: null,
        followABirder: null,
        resourcesTitle: null,
        resourcesDescription: null,
        resources: [{}],
        featuredExperience: [{}],
        locations: [],
      },
      outdoorsHref: '/experience-alabama/outdoor',
    };
  },
  methods: {
    reloadExperiencesMap(bounds) {
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      const params = `&min_latitude=${sw.lat()}&min_longitude=${ne.lng()}&max_latitude=${ne.lat()}&max_longitude=${sw.lng()}`;
      this.getExperienceLocations(params);
    },
    getPage() {
      butter.page.retrieve('*', 'birding', { preview: `${process.env.VUE_APP_BUTTER_PREVIEW}` })
        .then((res) => {
          this.page = res.data.data;
          this.experience.content = this.page.fields.description;
          this.experience.title = this.page.fields.title;
          this.experience.imageCaption = this.page.fields.hero_image_location;
          this.experience.imageLink = this.page.fields.hero_image_url;
          this.experience.imageAlt = this.page.fields.hero_image_alt;
          this.experience.iconName = this.page.fields.experience_image;
          this.experience.imageUrl = this.page.fields.hero_image;
          this.experience.sliderActionTitle = this.page.fields.slider_action_title;
          this.experience.sliderMainTitle = this.page.fields.slider_main_title;
          this.experience.sliderDesc = this.page.fields.slider_description;
          this.experience.birds = this.page.fields.birds;
          this.experience.flock = this.page.fields.find_your_flock;
          this.experience.followABirder = this.page.fields.follow_a_birder;
          this.experience.resourcesTitle = this.page.fields.resources_title;
          this.experience.resourcesDescription = this.page.fields.resources_description;
          this.experience.otherBirdingResources = this.page.fields.other_birding_resources;
          this.experience.featuredExperience = this.page.fields.featured_experiences;
          this.experience.crowdriffHeadline = this.page.fields.crowdriff_headline;
          this.experience.crowdriffSubtext = this.page.fields.crowdriff_subtext;
          this.experience.soundsTitle = this.page.fields.sounds_of_happy.sounds_title;
          this.experience.soundsDescription = this.page.fields.sounds_of_happy.sounds_description;
        }).catch((res) => {
          console.log(res);
        });
    },
    async getExperienceLocations(params) {
      const badge = this.birding_badge_id;
      await axios.get(`${process.env.VUE_APP_API2}filterLocations?badge_ids=${badge}${params}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      }).then((response) => {
        this.$nextTick(() => {
          const { locations } = response.data;
          let count = locations.length;
          let temp;
          let index;
          // shuffle
          while (count > 0) {
            // Pick a random index
            index = Math.floor(Math.random() * count);
            // Decrease count by 1
            count--;
            // And swap the last element with it
            temp = locations[count];
            locations[count] = locations[index];
            locations[index] = temp;
          }
          this.experience.locations = locations.map(location => ({ ...location, show: true }));
          this.loaded = true;
        });
      });
    },
  },
  async created() {
    await this.getPage();
    await this.getExperienceLocations('');
    await this.$store.dispatch('maps/setExperienceType', 8);
    await this.$store.dispatch('maps/setArea', '');
  },
})
class BirdingDetail extends Vue {
  get Breadcrumbs() {
    return [
      {
        text: 'Experience',
        href: '/experience-alabama',
      },
      {
        text: 'Outdoors',
        href: this.outdoorsHref,
      },
    ];
  }
}

export default BirdingDetail;
</script>

<style scoped>
.mb-100 {
  margin-bottom: 100px;
}

.cr-birding {
  margin-bottom: 0px !important;
}

.or-birding {
  margin-top: 100px;
}
</style>
